<form
  *ngIf="(state$ | async)?.form as form"
  [formGroup]="form"
  class="form">
  <app-input-vocabulary-autocomplete
    formControlName="tipo"
    [vocabularyName]="'V_Persona_tipo'"
    [placeholder]="'Tipo'">
  </app-input-vocabulary-autocomplete>
  <app-input-vocabulary-autocomplete
    formControlName="categoria"
    [vocabularyName]="'V_Persona_categoria'"
    [placeholder]="'Categoria'">
  </app-input-vocabulary-autocomplete>
  <mat-form-field>
    <input
      matInput
      formControlName="nome"
      [placeholder]="'Nome' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="cognome"
      [placeholder]="'Cognome' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="ragioneSociale"
      [placeholder]="'Rag. Sociale' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="partitaIva"
      [placeholder]="'P. IVA' | translate">
  </mat-form-field>
</form>
